// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__QLffL","mobile":"style_mobile__hnV9s","v3":"style_v3__Es-RU"};